import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import TeaCornerEvent from "../event/TeaCornerEvent";
import TeaCornerModel from "../model/TeaCornerModel";

export default class TeaCornerOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     * @param {TeaCornerModel} teaCornerModel 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(target, dispatcher, languagePack, teaCornerModel, variableManager) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._teaCornerModel = teaCornerModel;
        this._variableManager = variableManager;
    }

    initialize() {
        super.initialize();

        this._handleButtonBound = this._handleButton.bind(this);
        this._button = this.createButton(this._target, this._handleButtonBound, this._languagePack.getText(`hub.teaCorner.label`));
        this._button.setEnabled(false);

        this.registerEventListener(TeaCornerEvent.ENABLE_TEA_CORNER_BUTTON, this._handleEnableTeaCorner.bind(this));
        this.registerEventListener(TeaCornerEvent.DISABLE_TEA_CORNER_BUTTON, this._handleDisableTeaCorner.bind(this));
    }

    _handleEnableTeaCorner(evt) {
        this._button.setEnabled(true);
    }

    _handleDisableTeaCorner(evt) {
        this._button.setEnabled(false);
    }

    _handleButton() {
        // this._button.removeEventListener('click', this._handleButtonBound); // prevents the button from being clicked more than once
        const teaCornerContent = this._teaCornerModel.getCurrentContent();

        // Set a variable that marks this coffee corner dialog as visited - so that we can act upon it in the story
        this._variableManager.setVariable(`coffee_corner_${teaCornerContent.content.getLocationID()}_visited`, true);

        const evt = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_CONVERSATION_STATEMENT_AVAILABLE, teaCornerContent.content, teaCornerContent.contentPlayer);
        this.dispatch(evt.type, { data: evt });
    }
}